import { createAction } from "redux-act";

export const OpenExistingTargetModalAction = createAction("Existing Target - Open Modal");
export const CloseExistingTargetModalAction = createAction("Existing Target - Close Modal");
